module.exports = __webpack_public_path__ + "img/social-facebook.12de4ace.png";